
import english from "./Languages/en_US.json";
import japanese from "./Languages/ja_JP.json";
import chinese from "./Languages/zh_CN.json";
import spanish from "./Languages/es_ES.json";
import german from "./Languages/de_DE.json";
import french from "./Languages/fr_FR.json";
import italian from "./Languages/it_IT.json";
import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
// import XHR from 'i18next-xhr-backend'
// import Backend from 'i18next-http-backend'


i18n.use(LanguageDetector).use(LanguageDetector).use(initReactI18next).init({
    lng: "en_US",
    fallbackLng: "en_US",

    resources: {
        en_US: {
            translations: english
        },
        ja_JP: {
            translations: japanese
        },
        de_DE: {
            translations: german
        },
        es_ES: {
            translations: spanish
        },
        fr_FR: {
            translations: french
        },
        it_IT: {
            translations: italian
        },
        zh_CN: {
            translations: chinese
        }
    },
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    saveMissing: false,

    interpolation: {
        // escapeValue: false, // not needed for react!!
        formatSeparator: ',',
        format(value, format) {
            if (format === 'uppercase') return value.toUpperCase();
            return value;
        },
    },

    react: {
        defaultTransParent: 'div',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
});

export default i18n;